module.exports = __webpack_public_path__ + "static/media/blur.1d75e2df.gif";